<template>
  <div>
    <div class="modal-backdrop fade show import-contacts-backdrop" />
    <div
      class="modal fade show d-block import-contacts-modal"
      tabindex="-1"
      @keydown.esc="close(false)"
    >
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Importar contatos de projetos anteriores
            </h5>
            <button
              type="button"
              class="btn-close"
              title="Fechar"
              @click="close(false)"
            />
          </div>
          <div class="modal-body">
            <div v-if="loading" class="text-center py-4">
              <i class="ph ph-spinner spinner fs-3" />
            </div>
            <template v-else-if="contacts.length === 0">
              <p class="text-muted text-center mb-0">
                Nenhum contato encontrado em outros projetos deste cliente
              </p>
            </template>
            <template v-else>
              <div class="row g-3 align-items-center mb-3">
                <div class="col-lg-5 col-md-12">
                  <div
                    class="form-control-feedback form-control-feedback-start"
                  >
                    <input
                      type="search"
                      class="form-control"
                      placeholder="Buscar por nome ou e-mail"
                      v-model="filters.search"
                    />
                    <div class="form-control-feedback-icon">
                      <i class="ph ph-magnifying-glass" />
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <select class="form-select" v-model="filters.funcao">
                    <option value="">Todas as funções</option>
                    <option
                      v-for="option in optionsFuncao"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.text }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-4 col-md-6">
                  <div class="form-check form-switch mb-0">
                    <input
                      id="importContactsOnlyActive"
                      type="checkbox"
                      class="form-check-input"
                      v-model="filters.onlyActive"
                    />
                    <label
                      class="form-check-label"
                      for="importContactsOnlyActive"
                    >
                      Mostrar apenas ativos
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-sm table-bordered fs-sm mb-3">
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 40px">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          title="Selecionar todos"
                          :checked="allVisibleSelected"
                          :disabled="selectableVisibleContacts.length === 0"
                          @change="toggleAll($event.target.checked)"
                        />
                      </th>
                      <th>Nome</th>
                      <th>E-mail</th>
                      <th>Funções encontradas em outros projetos</th>
                      <th class="text-center">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="filteredContacts.length === 0">
                      <td colspan="5" class="text-center text-muted">
                        Nenhum contato encontrado com os filtros informados.
                      </td>
                    </tr>
                    <tr
                      v-for="contact in filteredContacts"
                      :key="contact.email"
                      :class="{ 'text-muted bg-light': contact.jaCadastrado }"
                    >
                      <td class="text-center">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          :checked="isContactSelected(contact)"
                          :disabled="contact.jaCadastrado"
                          @change="
                            toggleContact(contact, $event.target.checked)
                          "
                        />
                      </td>
                      <td>
                        {{ contact.nome }}
                        <div
                          v-if="contact.jaCadastrado"
                          class="text-primary small mt-1"
                        >
                          <i class="ph ph-info" /> Já cadastrado neste projeto
                        </div>
                      </td>
                      <td>{{ contact.email }}</td>
                      <td>
                        <div
                          v-for="funcao in contact.funcoes"
                          :key="funcao.funcao"
                          class="form-check mb-1"
                        >
                          <input
                            :id="`import-${contact.email}-${funcao.funcao}`"
                            type="checkbox"
                            class="form-check-input"
                            :checked="funcao.jaCadastrado || funcao.selected"
                            :disabled="funcao.jaCadastrado"
                            @change="funcao.selected = $event.target.checked"
                          />
                          <label
                            class="form-check-label"
                            :for="`import-${contact.email}-${funcao.funcao}`"
                            :title="
                              funcao.jaCadastrado
                                ? 'Função já cadastrada neste projeto'
                                : ''
                            "
                          >
                            {{ funcaoContatoLabel(funcao.funcao) }}
                          </label>
                        </div>
                      </td>
                      <td
                        v-html="statusTranslate(contact.status)"
                        class="text-center"
                      />
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="alert alert-info d-flex align-items-start mb-0">
                <i class="ph ph-info fs-5 me-2" />
                <div>
                  <strong>{{ selectedContactsCount }}</strong>
                  {{
                    selectedContactsCount === 1
                      ? 'contato selecionado'
                      : 'contatos selecionados'
                  }}
                  <span class="mx-2">|</span>
                  <strong>{{ selectedFunctionsCount }}</strong>
                  {{
                    selectedFunctionsCount === 1
                      ? 'vínculo de função será adicionado'
                      : 'vínculos de função serão adicionados'
                  }}
                  <div class="small mt-1">
                    Contatos já cadastrados neste projeto são exibidos
                    desabilitados.
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-link"
              title="Cancelar"
              @click="close(false)"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              title="Importar selecionados"
              :disabled="selectedFunctionsCount === 0 || disableButton"
              @click="importContacts"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>Importar selecionados</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { funcaoContatoLabel, statusTranslate } from '@/utils/strings'

export default {
  name: 'ImportContactsClientModal',

  props: {
    clientId: {
      type: String,
      required: true,
    },
    optionsFuncao: {
      type: Array,
      required: true,
    },
  },

  emits: ['closeModal'],

  data() {
    return {
      contacts: [],
      filters: {
        search: '',
        funcao: '',
        onlyActive: true,
      },
      loading: true,
      disableButton: false,
      funcaoContatoLabel,
      statusTranslate,
    }
  },

  computed: {
    filteredContacts() {
      const search = this.filters.search.trim().toLowerCase()

      return this.contacts.filter((contact) => {
        if (this.filters.onlyActive && parseInt(contact.status, 10) !== 1) {
          return false
        }
        if (
          this.filters.funcao !== '' &&
          !contact.funcoes.some((f) => f.funcao === this.filters.funcao)
        ) {
          return false
        }
        if (
          search &&
          !contact.nome.toLowerCase().includes(search) &&
          !contact.email.toLowerCase().includes(search)
        ) {
          return false
        }
        return true
      })
    },

    selectableVisibleContacts() {
      return this.filteredContacts.filter((contact) => !contact.jaCadastrado)
    },

    allVisibleSelected() {
      return (
        this.selectableVisibleContacts.length > 0 &&
        this.selectableVisibleContacts.every((contact) =>
          this.selectableFunctions(contact).every((f) => f.selected),
        )
      )
    },

    selectedContactsCount() {
      return this.contacts.filter((contact) => this.isContactSelected(contact))
        .length
    },

    selectedFunctionsCount() {
      return this.contacts.reduce(
        (total, contact) =>
          total + contact.funcoes.filter((f) => f.selected).length,
        0,
      )
    },
  },

  methods: {
    async getContactsToImport() {
      try {
        const contacts = await this.$store.dispatch(
          'getContactsToImportClient',
          this.clientId,
        )
        this.contacts = (contacts || []).map((contact) => ({
          ...contact,
          funcoes: contact.funcoes.map((f) => ({ ...f, selected: false })),
        }))
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.close(false)
      } finally {
        this.loading = false
      }
    },

    selectableFunctions(contact) {
      return contact.funcoes.filter((f) => !f.jaCadastrado)
    },

    isContactSelected(contact) {
      return contact.funcoes.some((f) => f.selected)
    },

    toggleContact(contact, checked) {
      this.selectableFunctions(contact).forEach((f) => {
        f.selected = checked
      })
    },

    toggleAll(checked) {
      this.selectableVisibleContacts.forEach((contact) =>
        this.toggleContact(contact, checked),
      )
    },

    async importContacts() {
      const contatos = this.contacts
        .filter((contact) => this.isContactSelected(contact))
        .map((contact) => ({
          email: contact.email,
          funcoes: contact.funcoes
            .filter((f) => f.selected)
            .map((f) => f.funcao),
        }))

      this.disableButton = true
      try {
        const response = await this.$store.dispatch('importContactsClient', {
          clienteId: this.clientId,
          contatos,
        })

        if (
          response.data &&
          response.data.erros &&
          response.data.erros.length
        ) {
          this.$root.$refs.notification.warning(response.message)
        } else {
          this.$root.$refs.notification.success(response.message)
        }
        this.close(true)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    close(imported) {
      this.$emit('closeModal', imported)
    },
  },

  mounted() {
    this.getContactsToImport()
  },
}
</script>

<style scoped>
.import-contacts-backdrop {
  z-index: 1060;
}

.import-contacts-modal {
  z-index: 1065;
}
</style>
